import { DateTime } from 'luxon';
import { List } from "immutable";
import { catchBlockErrors } from "../utils/sentry";


// When saving a users layers, we have to convert the dates to strings before we
// make the post request
export const convertDatesInLayers = (layers=List([])) => {
    let convertedLayers = layers;
    try {
        const datesKeyPath = ['dateRange', 'dates'];
        convertedLayers= convertedLayers.filter(layer => {
            if (layer === null || layer === undefined) return false;

            const layerType = layer.get('layerType', '');
            const dates = layer.getIn(datesKeyPath, false);
            if (layerType !== 'application' && layerType !== 'retro') return false;
            if (!dates) return false;
            return true;
        });
        convertedLayers = convertedLayers.map(layer => {
            const datesKeyPath = ['dateRange', 'dates'];
            const datesArray = layer.getIn(datesKeyPath, List([]));
            const updatedDatesArray = datesArray.map(date => DateTime.fromISO(date));
            const updatedLayer = layer.setIn(datesKeyPath, updatedDatesArray);
            return updatedLayer;
        })
    } catch(error){
        catchBlockErrors({
            error,
            'file/function': 'convertDatesInLayers/convertDatesInLayers'
        })
    } finally {
        return convertedLayers;
    }
};
